// BMC-Fonts self-hosted (DSGVO: kein Google-CDN) — Space Grotesk (Display),
// Inter (Body), JetBrains Mono (Mono). Weights gemäß TP1-Design-Spec.
import '@fontsource/space-grotesk/500.css'
import '@fontsource/space-grotesk/600.css'
import '@fontsource/space-grotesk/700.css'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
// Tailwind + shadcn-Fundament (single source of truth für das BMC-Theme).
import '../ui/theme.css'
// BMC-Konsolen-Designsystem (marcapo-Layout-Qualität in BMC-Farben, gescoped
// auf .vcard-editor-root). Quelle: design/bmc/console-redesign.html.
import '../ui/console.css'

import { Outlet } from 'react-router-dom'
import { ThemeProvider, useTheme } from './contexts/ThemeContext'
import { AuthProvider } from './contexts/AuthContext'
import { BrandProvider } from './contexts/BrandContext'
import { Toaster } from '@/ui/sonner'

/** Trägt die Design-Scope-Klasse und rendert den aktiven
 *  Console-Bereich (`/login`, `/admin/*`, `/editor/*`) via <Outlet/>. */
function ThemedConsoleRoot() {
  const { theme } = useTheme()
  return (
    <div className="vcard-editor-root">
      <Outlet />
      {/* Globaler Toast-Host (shadcn/sonner) — Theme wird durchgereicht (CO-2),
          hängt immer unter dem ThemeProvider. */}
      <Toaster theme={theme} />
    </div>
  )
}

/**
 * Gemeinsamer Provider-Stack für die gesamte Konsole (TP2 §D2): Theme → Auth →
 * Brand werden **einmal** für `/login`, `/admin/*` und `/editor/*` gemountet.
 * Der Bereichswechsel admin↔editor löst dadurch kein Session-Neubootstrap aus.
 * Der öffentliche Viewer (`/`, `/:urlKey`) bleibt außerhalb dieses Stacks.
 */
export function ConsoleProviders() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrandProvider>
          <ThemedConsoleRoot />
        </BrandProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default ConsoleProviders
